module.exports = __webpack_public_path__ + "assets/yuantong.00d32b12.svg";